import { css } from '@lastbrand/web-ui-styled-system/css'

import { optionBoxRecipe } from './option-selector-shared.styles'

// DS twin of textOption.module.scss (new-design-V2 look). Selected = filled black bg + white text.
export const textLabelClass = css(optionBoxRecipe.raw(), {
  textStyle: 'body-14',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  minWidth: '50px', // px literal (no size token)
  paddingBlock: 'space-10',
  paddingInline: 'space-16',
  borderRadius: 'radius-none',
  backgroundColor: 'white',
  color: 'black',
  // selected fills the box (bg black + white text) on top of the shared border darken.
  'input:checked + &, input:focus-visible + &': {
    backgroundColor: 'black',
    color: 'white',
  },
  // disabled → grey border + muted text.
  'input:disabled + &': {
    borderColor: 'lightgray',
    color: 'mediumgray',
    backgroundColor: 'white',
  },
})
